import { inject, Injectable } from '@angular/core';
import {
  CookieHelperService,
  LoginRememberMeUtilsService,
  UserDataService
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import {
  CRAM_BBIZ_NAME,
  IS_CRAM_BBIZ_REGEX,
  PERM_TYPE,
  PROGRAM_TYPE
} from '../constants/profile-selector-constants';

@Injectable({
  providedIn: 'root'
})
export class ProfileSelectorUtilHelperService {
  loginRememberMeUtils = inject(LoginRememberMeUtilsService);
  userData = inject(UserDataService);
  cookieHelper = inject(CookieHelperService);

  checkForBusiness(permType: string): boolean {
    let businessType = false;
    businessType =
      permType === PERM_TYPE.B || permType === PERM_TYPE.NA ? true : false;
    return businessType;
  }

  checkForAdmin(permType: string): boolean {
    let businessType = false;
    businessType = permType === PERM_TYPE.A ? true : false;
    return businessType;
  }

  checkForSkyBonus(permType: string): boolean {
    let businessType = false;
    businessType = permType === PERM_TYPE.S ? true : false;
    return businessType;
  }

  switchBusinessAccountOverlayHelper(
    elementTag: HTMLElement,
    permType: string
  ): boolean {
    return elementTag && permType !== PERM_TYPE.P && permType !== PERM_TYPE.A;
  }

  displayBusinessPath(type: string, program: string): boolean {
    return (
      (type === PERM_TYPE.A && program !== PROGRAM_TYPE.SKB) ||
      (type === PERM_TYPE.S && program !== PROGRAM_TYPE.SKB)
    );
  }

  displayOnlySkyBonusPath(type: string, program: string): boolean {
    return type === PERM_TYPE.S && program === PROGRAM_TYPE.SKB;
  }

  navigateUrl(url: string): void {
    window.location.href = url;
  }

  hasAdminAndSkyBonusPath(type: string, program: string): boolean {
    return !!type.match(/S,A/i) && PROGRAM_TYPE.SKYB === program;
  }

  getFullCramBBizName(name: string): string {
    return CRAM_BBIZ_NAME[name];
  }

  getName(name: string): string {
    const length = name.length;
    const isCramOrBBiz = IS_CRAM_BBIZ_REGEX.test(name);
    if (isCramOrBBiz && length <= 4) {
      const newName = this.getFullCramBBizName(name);
      return newName;
    } else {
      return name;
    }
  }

  getDisplayName(name: string, corpId: string): string {
    const length = name.length;

    const isCramOrBBiz = IS_CRAM_BBIZ_REGEX.test(name);
    if (isCramOrBBiz && length <= 4) {
      const newName = this.getFullCramBBizName(name);
      return `${newName}\n ${corpId}`;
    } else {
      return name;
    }
  }
}
